import { Spin } from "antd";
import styled from "styled-components";

type LoadingDefaultSpinIndicatorProps = {
  isShown: boolean;
  children?: React.ReactNode;
};

const Container = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;
`;

const LoadingDefaultSpinIndicator: React.FC<
  LoadingDefaultSpinIndicatorProps
> = ({ isShown, children }) => {
  if (isShown) {
    return (
      <Container>
        <Spin></Spin>
      </Container>
    );
  }

  return <>{children}</>;
};

export default LoadingDefaultSpinIndicator;
